/* eslint-disable react/display-name */
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import AirplanemodeActiveIcon from '@material-ui/icons/AirplanemodeActive';
import CompareIcon from '@material-ui/icons/Compare';
import DashboardIcon from '@material-ui/icons/Dashboard';
import EcoIcon from '@material-ui/icons/Eco';
import EditIcon from '@material-ui/icons/Edit';
import ListIcon from '@material-ui/icons/List';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import RedeemIcon from '@material-ui/icons/Redeem';
import React from 'react';
import { RouteProps } from 'react-router-dom';
import { FlagIcon } from '../../assets/Svg';
import Search from '../../pages/search';
import settings from '../../services/settings';
import ABTest from '../abtest';
import BundlePackage from '../bundlePackage';
import Giftbox from '../coupon/giftbox';
import RedeemCode from '../coupon/redeemcode';
import FreeStory from '../freeStory';
import AutomatedCollection from '../home/automatedCollection';
import Collection from '../home/collection';
import DisplayStyle from '../home/displayStyle';
import FeaturedCard from '../home/featuredCard';
import Link from '../home/link';
import UserSegment from '../home/userSegment';
import Keyword from '../keyword';
import LuckyDraw from '../luckyDraw';
import Moderation from '../moderation';
import Payment from '../payment';
import Penname from '../penname';
import ReadingChallenge from '../readingChallenge';
import RelatedStories from '../relatedStory';
import Reports from '../reports';
import SaleStory from '../saleStory';
import Theme from '../theme';
import WriterAccount from '../writerAccount';
import OnboardingFlow from '../onboarding/flow';
import OnboardingLane from '../onboarding/lane';

export const RouteNames = {
  OnboardingFlow: '/onboarding/flow',
  OnboardingLane: '/onboarding/lane',
  UserSegment: '/home/user-segment',
  Moderation: '/moderation',
  FeaturedCard: '/home/featured-card',
  Collection: '/home/collection',
  AutomatedCollection: '/home/automated-collection',
  Link: '/home/link',
  Giftbox: '/coupon/giftbox',
  LuckyDraw: '/event/lucky-draw',
  GiftboxLuckyDraw: '/event/giftbox-lucky-draw',
  ReadingChallenge: '/event/reading-challenge',
  DisplayStyle: '/home/display-style',
  FreeStoryScheduling: '/event/free-story-scheduling',
  SaleStoryScheduling: '/event/sale-story-scheduling',
  SearchFeature: '/keyword',
  SearchResult: '/search',
  RedeemCode: '/coupon/redeemcode',
  Report: '/reports',
  RelatedStory: '/related-story',
  Abtest: '/abtest',
  BundlePackage: '/bundle-package',
  Theme: '/theme',
  Penname: '/penname',
  WriterAccount: '/writer-account',
  Payment: '/payment',
};

export type IRouteProps = RouteProps & { externalLink?: string };

interface RadishAdminPageConfig {
  menuProps?: {
    name: string;
    IconComponent?: React.ComponentType<SvgIconProps> /* https://material.io/resources/icons */;
    unexposed?: boolean;
  };
  routeProps?: IRouteProps;
  nestedMenus?: RadishAdminPageConfig[];
}

const pageConfigs: RadishAdminPageConfig[] = [
  // Removed due to https://radish.atlassian.net/browse/RS-3760
  {
    menuProps: {
      name: 'Search Result',
      unexposed: true,
    },
    routeProps: {
      path: RouteNames.SearchResult,
      component: Search,
      exact: true,
    },
  },
  {
    menuProps: {
      name: 'Onboarding',
      IconComponent: AirplanemodeActiveIcon,
    },
    nestedMenus: [
      {
        menuProps: {
          name: 'Onboarding Flows',
        },
        routeProps: {
          path: RouteNames.OnboardingFlow,
          component: OnboardingFlow,
        },
      },
      {
        menuProps: {
          name: 'Onboarding Lanes',
        },
        routeProps: {
          path: RouteNames.OnboardingLane,
          component: OnboardingLane,
        },
      },
    ],
  },
  {
    menuProps: {
      name: 'Segments',
      IconComponent: PeopleAltIcon,
    },
    routeProps: {
      path: RouteNames.UserSegment,
      component: UserSegment,
    },
  },
  {
    menuProps: {
      name: 'Collections',
      IconComponent: DashboardIcon,
    },
    nestedMenus: [
      {
        menuProps: {
          name: 'Featured Cards',
        },
        routeProps: {
          path: RouteNames.FeaturedCard,
          component: FeaturedCard,
        },
      },
      {
        menuProps: {
          name: 'Links',
        },
        routeProps: {
          path: RouteNames.Link,
          component: Link,
        },
      },
      {
        menuProps: {
          name: 'Manual Collections',
        },
        routeProps: {
          path: RouteNames.Collection,
          component: Collection,
        },
      },
      {
        menuProps: {
          name: 'Automated Collections',
        },
        routeProps: {
          path: RouteNames.AutomatedCollection,
          component: AutomatedCollection,
        },
      },
    ],
  },
  {
    menuProps: {
      name: 'Story AB Test',
      IconComponent: CompareIcon,
    },
    routeProps: {
      path: RouteNames.Abtest,
      component: ABTest,
    },
  },
  {
    menuProps: {
      name: 'Coupon',
      IconComponent: LocalOfferIcon,
    },
    nestedMenus: [
      {
        menuProps: {
          name: 'Redeem Code',
        },
        routeProps: {
          path: RouteNames.RedeemCode,
          component: RedeemCode,
          exact: true,
        },
      },
      {
        menuProps: {
          name: 'Gift Box',
        },
        routeProps: {
          path: RouteNames.Giftbox,
          component: Giftbox,
        },
      },
    ],
  },
  {
    menuProps: {
      name: 'Events',
      IconComponent: RedeemIcon,
    },
    nestedMenus: [
      {
        menuProps: {
          name: 'Lucky Draws',
        },
        routeProps: {
          path: RouteNames.LuckyDraw,
          component: LuckyDraw,
        },
      },
      {
        menuProps: {
          name: 'Reading Challenges',
        },
        routeProps: {
          path: RouteNames.ReadingChallenge,
          component: ReadingChallenge,
        },
      },
      {
        menuProps: {
          name: 'Free Story Scheduling',
        },
        routeProps: {
          path: RouteNames.FreeStoryScheduling,
          component: FreeStory,
        },
      },
      {
        menuProps: {
          name: 'Sale Story Scheduling',
        },
        routeProps: {
          path: RouteNames.SaleStoryScheduling,
          component: SaleStory,
        },
      },
      {
        menuProps: {
          name: 'Gift Box Lucky Draws',
        },
        routeProps: {
          path: RouteNames.GiftboxLuckyDraw,
          component: LuckyDraw,
        },
      },
    ],
  },
  {
    menuProps: {
      name: 'Miscellaneous',
      IconComponent: EcoIcon,
    },
    nestedMenus: [
      {
        menuProps: {
          name: 'Themes',
        },
        routeProps: {
          path: RouteNames.Theme,
          component: Theme,
        },
      },
      {
        menuProps: {
          name: 'Search Feature',
        },
        routeProps: {
          path: RouteNames.SearchFeature,
          component: Keyword,
          exact: true,
        },
      },
      {
        menuProps: {
          name: 'Display Styles',
        },
        routeProps: {
          path: RouteNames.DisplayStyle,
          component: DisplayStyle,
        },
      },
      {
        menuProps: {
          name: 'Related Stories',
        },
        routeProps: {
          path: RouteNames.RelatedStory,
          component: RelatedStories,
        },
      },
      {
        menuProps: {
          name: 'Reports',
        },
        routeProps: {
          path: RouteNames.Report,
          component: Reports,
          exact: true,
        },
      },
    ],
  },
  {
    menuProps: {
      name: 'Moderation',
      IconComponent: FlagIcon,
    },
    routeProps: {
      path: RouteNames.Moderation,
      component: Moderation,
    },
  },
  {
    menuProps: {
      name: 'Bundle Package',
      IconComponent: ListIcon,
    },
    routeProps: {
      path: RouteNames.BundlePackage,
      component: BundlePackage,
    },
  },
  {
    menuProps: {
      name: 'Writers',
      IconComponent: EditIcon,
    },
    nestedMenus: [
      {
        menuProps: {
          name: 'Pen Names',
        },
        routeProps: {
          path: RouteNames.Penname,
          component: Penname,
        },
      },
      {
        menuProps: {
          name: 'Writer Accounts',
        },
        routeProps: {
          path: RouteNames.WriterAccount,
          component: WriterAccount,
        },
      },
      {
        menuProps: {
          name: 'Payments',
        },
        routeProps: {
          path: RouteNames.Payment,
          component: Payment,
        },
      },
    ],
  },
];

export default pageConfigs;
